import React from "react";
import Sidebar from "../../components/Sidebar";
import KYCDashboard from "../../components/ui/card";
import { useAllKyc, useAllUsers } from "../../services/queries/queries";


const Dashboard = () => {


  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      {/* Sidebar handles its own desktop/mobile rendering */}
      <Sidebar />

      {/* Main content — scrolls independently */}
      <div className="overflow-y-auto flex-1 p-4 px-8 md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Dashboard</h1>
        <div className="">
        <KYCDashboard />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
